export default "__VITE_ASSET__D52VGara__"